import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WorkOrderCard } from '../../models/work-order';
import { WorkOrderCardInterface } from '../../interface/work-order-card';
import { WorkOrderService } from '../../../services/work-order.service';
import { AccountService } from '../../../services/account.service';
import { ErrorService } from 'services/error.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-work-order-dashboard',
  templateUrl: './work-order-dashboard.component.html',
  styleUrls: ['./work-order-dashboard.component.css']
})
export class WorkOrderDashboardComponent implements OnInit {

  errorMessage: string = null;
  workOrders: WorkOrderCardInterface[] = [];
  pastWorkOrders: WorkOrderCardInterface[] = [];
  refresh: string;
  showCreateCard = false;
  triconPhoneNumberDotFormat = environment.triconPhoneDotFormat;
  triconPhoneNumber = environment.triconPhone;
  appStoreUrl = environment.mobileApp.appStoreUrl;
  googlePlayUrl = environment.mobileApp.googlePlayUrl;

  constructor(private router: Router, private accountService: AccountService, private workOrderService: WorkOrderService, private errorService: ErrorService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.getResidentStatus();
  }

  getResidentStatus() {
    this.accountService.getResidentStatus()
      .subscribe(res => this.onGetResidentStatusSuccess(res), err => this.accountService.handleError(err));
  }
  onGetResidentStatusSuccess(res) {
    if (!res) {
      this.router.navigate(['/application/dashboard']);
    }
  }

  createWorkOrder() {
    this.router.navigate(['/maintenance/create']);
  }

  onCanCreateWorkOrderResponse(canCreate: any) {
    if (canCreate) {
      this.showCreateCard = true;
    } else {
      this.errorService.showError("You are not allowed to create maintenance requests");
    }
    this.workOrderService.getAllWorkOrders().subscribe(res => this.onGetWorkOrdersForDashboard(res), err => this.accountService.handleError(err));
  }

  async onGetWorkOrdersForDashboard(returnedWorkOrders: WorkOrderCardInterface[]) {
    if (this.refresh === "true") {
      this.refresh = "false";
      this.workOrders.push(this.createSpinnerCard());
      
      this.workOrders = returnedWorkOrders.filter(a => a.Status=== "In Progress" || a.Status === "Submitted");
      this.workOrders.sort((a,b) => b.CreatedDate.getTime() - a.CreatedDate.getTime());
      this.pastWorkOrders = returnedWorkOrders.filter(a => a.Status=== "Completed" || a.Status === "Cancelled");
      this.pastWorkOrders.sort((a,b) => b.CreatedDate.getTime() - a.CreatedDate.getTime());

    }
    this.workOrders = returnedWorkOrders.filter(a => a.Status=== "In Progress" || a.Status === "Submitted");
    this.workOrders.sort((a,b) => b.CreatedDate.getTime() - a.CreatedDate.getTime());
    this.pastWorkOrders = returnedWorkOrders.filter(a => a.Status=== "Completed" || a.Status === "Cancelled");
    this.pastWorkOrders.sort((a,b) => b.CreatedDate.getTime() - a.CreatedDate.getTime());
  }

  handleError(error: any) {
    this.errorService.showError("An error occurred while checking work order creation permissions");
  }

  createSpinnerCard() {
    let spin = new WorkOrderCard();
    spin.DefaultCard = true;
    return spin;
  }
}
